import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {db} from '../Base';
import { storage } from '../Base';
import {collection, getDocs, query, orderBy} from 'firebase/firestore';



function Standings() {
  
  const [standing, setStanding] = useState([]);

  const usersCollectionRef = collection(db, "standing");

  const q = query(usersCollectionRef, orderBy("position", "asc"));

  const getData = async () => {
    const data = await getDocs(q, usersCollectionRef)
    setStanding(data.docs.map((doc) => ({...doc.data(), id:doc.id})));
}


useEffect(() => {
    getData();
}, []);

  
  return (
    <Div>
      <Div1>
        <h2>LEAGUE TABLE</h2>
        <table>
    <tr>
      <th>Position</th>
      <th>Team</th>
      <th>W-L</th>
      <th>GP</th>
      <th>W</th>
      <th>L</th>
      <th>Pts+</th>
      <th>Pts-</th>
      <th>PD</th>
    </tr>

    {standing.map(({id, points_scored, points_difference, points_against, losses, wins, games_played, team, position, win_loss}) => (
    <tr key={id}>
    <td>{position}</td>
    <td>{team}</td>
    <td>{win_loss}</td>
    <td>{games_played}</td>
    <td>{wins}</td>
    <td>{losses}</td>
    <td>{points_scored}</td>
    <td>{points_against}</td>
    <td>{points_difference}</td>
    </tr>
    ))}

        </table>
      </Div1>


    </Div>
  )
}

export default Standings

const Div = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
width: 100%;

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
`

const Div1 = styled.div`
height: 60vh;
width: 100%;
`
